const l = {
  name: "PayByLink",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 7.25C18.69 7.25 19.25 6.69 19.25 6C19.25 5.31 18.69 4.75 18 4.75C17.31 4.75 16.75 5.31 16.75 6C16.75 6.69 17.31 7.25 18 7.25Z" fill="currentColor"/>
<path d="M20 1H13V11H23V4C23 2.34772 21.6523 1 20 1ZM15 9V3H20C20.5477 3 21 3.45228 21 4V9H15Z" fill="currentColor"/>
<path d="M7.25 18C7.25 18.69 6.69 19.25 6 19.25C5.31 19.25 4.75 18.69 4.75 18C4.75 17.31 5.31 16.75 6 16.75C6.69 16.75 7.25 17.31 7.25 18Z" fill="currentColor"/>
<path d="M11 13H1V20C1 21.6523 2.34772 23 4 23H11V13ZM3 20V15H9V21H4C3.45228 21 3 20.5477 3 20Z" fill="currentColor"/>
<path d="M14 15.25C14.69 15.25 15.25 14.69 15.25 14C15.25 13.31 14.69 12.75 14 12.75C13.31 12.75 12.75 13.31 12.75 14C12.75 14.69 13.31 15.25 14 15.25Z" fill="currentColor"/>
<path d="M1 5H11V7H1V5Z" fill="currentColor"/>
<path d="M11 1H1V3H11V1Z" fill="currentColor"/>
<path d="M23 23V21H13V23H23Z" fill="currentColor"/>
<path d="M23 13H17V15H23V13Z" fill="currentColor"/>
<path d="M13 17H23V19H13V17Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as PayByLink
};
